import { createSlice } from '@reduxjs/toolkit'

export const STARTUP_COMPLETED = 'startup/completed'

// reducer
const startupSlice = createSlice({
  name: 'startup',
  initialState: {
    initing: true,
    fetching: false,
  },
  reducers: {
    initCompleted: (state) => {
      return { ...state, initing: false }
    },
  },
})

export const { initCompleted } = startupSlice.actions

export default startupSlice.reducer

export const selectStartup = (state) => state.startup
export const selectStartupIniting = (state) => state.startup.initing
